// TopHeader.jsx
import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '../components/ui/avatar';
import QuizrrLogoMobile from '../../public/Images/QuizrrLogoMobile.png';
import { useLocation, useNavigate } from 'react-router-dom';
import { usePackStorage } from './usePackStorage';

function TopHeader() {
  const user = JSON.parse(localStorage.getItem('userProfile'));
  const navigate = useNavigate();
  const location = useLocation();

  const { purchasedPacks } = usePackStorage();

  const handleProfileClick = () => {
    if (location.pathname === '/no-test-series-purchased') {
      // pass flag if coming from no-test-series page
      navigate('/v3/profile', { state: { fromNoSeries: true } });
    } else {
      navigate('/v3/profile');
    }
  };

  return (
    <header className="mb-5 px-4 md:px-2 flex items-center justify-between flex-shrink-0 ">
      <div className=" items-center gap-2 flex md:hidden">
        <img alt="Quizrr" src={QuizrrLogoMobile} width="60px" />
      </div>
      <div className=" items-center gap-1 hidden md:flex">
        <span>👋</span>
        <span className="text-[var(--q3-neutral-light)] font-medium text-sm">
          Hey, {user?.name || 'User'} {purchasedPacks && purchasedPacks.length > 0 && 'you are viewing'}
        </span>
      </div>
      <div
        onClick={handleProfileClick}
        className="flex flex-row cursor-pointer gap-3 items-center font-medium text-sm text-[var(--q3-neutral-default)] "
      >
        <div className="flex flex-col text-right text-sm font-medium">
          <span>{user?.email}</span>
          <span>{user?.mobileNumber}</span>
        </div>

        <Avatar className="cursor-pointer">
          <AvatarImage src={user?.profilePicture} alt={user?.name} />
          <AvatarFallback>{user?.name?.slice(0, 1)}</AvatarFallback>
        </Avatar>
      </div>
    </header>
  );
}

export default TopHeader;
